import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { CLIENT_ID_SESSION_KEY, CLIENT_ID_HEADER } from '@sopranodesign/pulse-auth';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Accept'] = 'application/json';

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const clientId = sessionStorage.getItem(CLIENT_ID_SESSION_KEY);

  if (clientId) {
    config.headers[CLIENT_ID_HEADER] = clientId;
  }

  return config;
});

const defaultQueryFn = async ({ queryKey }) => {
  const controller = new AbortController();
  const [key, params = {}] = queryKey;

  const promise = axios.get(key, {
    params,
    signal: controller.signal
  });

  promise.cancel = () => {
    controller.abort();
  };

  const { data } = await promise;
  return data;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: true,
      queryFn: defaultQueryFn,
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    },
    mutations: {
      enabled: true
    }
  }
});

export default queryClient;